import error from '@/i18n/en/error';
import colleges from '@/i18n/en/colleges';
import students from '@/i18n/en/students';
import reports from '@/i18n/en/reports';
import courses from '@/i18n/en/courses';
import districtAdmins from '@/i18n/en/districtAdmins';
import campusGroupAdmins from '@/i18n/en/campusGroupAdmins';
import directiveAdmins from '@/i18n/en/directiveAdmins';
import calendarTypes from '@/i18n/en/calendarTypes';
import conglomerates from '@/i18n/en/conglomerates';
import diagnostics from '@/i18n/en/diagnostics';
import demos from '@/i18n/en/demos';
import studentSatisfaction from '@/i18n/en/studentSatisfaction';
import surveys from '@/i18n/en/surveys';
import supportRequests from '@/i18n/en/supportRequests';
import classlink from '@/i18n/en/classlink';
import adminActionLogs from '@/i18n/en/adminActionLogs';

export default {
  hello: 'Hello',
  footer_cs_love: 'With ❤️ for the Customer Success team',
  login: {
    title: 'Achool administrator',
    subtitle: 'Enter your username and password',
    user_input: 'Username',
    password_input: 'Password',
    login_btn: 'Log in',
    register_btn: 'Registrar',
    password_required: 'Password required',
    email_required: 'Email is required',
    email_format_validation: 'Email format is wrong',
    dont_have_account: "Don't have an account?",
    register_link: 'Register here',
    login_button: 'Login',
  },
  register: {
    title: 'Register',
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
    password_input: 'Password',
    repeat_password_input: 'Confirm your password',
    back: 'Back',
    password_not_match: 'Password does not match',
    password_length: 'Password must be at least 8 characters long',
    school_group: 'Select the school group',
  },
  layout: {
    colleges: 'Colleges',
    conglomerates: 'Conglomerates',
    students: '🎓 Students',
    teachers: '🧑‍🏫 Teachers',
    'district-admins': '👨‍💼 District Admins',
    'campus-group-admins': '🏫 Campus Group Admins',
    'directive-admins': 'Directive Admins',
    edition: 'Edition',
  },
  all_colleges: 'All Schools',
  error,
  colleges,
  students,
  reports,
  courses,
  district_admins: districtAdmins,
  campus_group_admins: campusGroupAdmins,
  directive_admins: directiveAdmins,
  calendar_types: calendarTypes,
  conglomerates,
  diagnostics,
  demos,
  studentSatisfaction,
  surveys,
  supportRequests,
  classlink,
  adminActionLogs,
  teachers: {
    label: 'teachers',
    name: 'Name',
    all_teachers: 'All Teachers',
    create: 'Create New Teacher',
    general_information: 'Teacher Information',
    impersonate_select_app: 'Select application to impersonate',
    impersonate_teachers_app: 'Teachers App',
    impersonate_teachers_app_desc: 'Access the teachers application',
    impersonate_datasystem: 'DataSystem',
    impersonate_datasystem_desc: 'Access the reports and data panel',
    courses_assigned: 'Assigned courses',
    courses: 'Courses (optional)',
    add_course: 'Add a course from this school',
    no_courses_assigned: 'This teacher has no assigned courses.',
    no_courses_available: 'No courses available in this school to add.',
    course_new: 'new',
    course_inactive: 'Inactive',
    inactive_courses: 'Inactive courses (not shown in the teachers app)',
    inactive_courses_count: '{count} inactive course | {count} inactive courses',
    undo: 'Undo',
    unsaved_changes: 'You have unsaved changes',
    discard_changes: 'Discard changes',
    save_changes: 'Save changes',
    leave_confirm: 'If you leave now, your unsaved changes will be lost.',
    save_summary_title: 'Confirm changes',
    save_summary_intro: 'You are about to apply these course changes:',
    summary_add: 'Add',
    summary_remove: 'Remove',
    remove_course_other_school: 'belongs to another school — the assignment will be removed',
  },
  common: {
    all: 'All',
    filter: 'Filters',
    filter_by: 'Filter by',
    to_disable: 'Disable',
    to_enable: 'Enable',
    student: 'Student',
    disable_message: 'By performing this action the account will be disabled. Are you sure you want to perform this action?',
    enable_message: 'By performing this action the account will be enabled. Are you sure you want to perform this action?',
    cancel: 'Cancel',
    close: 'Close',
    send: 'Send',
    to_save: 'Save',
    to_select: 'Select',
    to_transfer: 'Transfer',
    field_required: 'This field is required',
    an_error_ocurred: 'An error has occurred',
    support_text: 'Unexpected error in the application.',
    support_desc: 'Please take a screenshot of this bug and send it to the technology team.',
    save: 'Save',
    search: 'Search',
    clear_filter: 'Clear filters',
    status: 'Status',
    create: 'Create',
    delete: 'Delete',
  },
  subscription: {
    overdue: 'Overdue',
  },
  navigation: {
    colleges: 'Colleges',
    conglomerates: 'Conglomerates',
    students: '🎓 Students',
    teachers: 'Teachers',
    parents: 'Parents',
    reports: 'Reports',
    district_admins: '🏛️ District Admins',
    campus_group_admins: '🏫 Campus Group Admins',
    directive_admins: 'Directives',
    school_admin: 'School Admin',
    calendar_types: 'Calendar Types',
    diagnostics: '📝 Diagnostics',
    users: '👥 Users',
    demos: 'Demos',
    surveys: 'Surveys',
    support_requests: '🎫 Approval inbox',
    integrations: '🔌 Integrations',
    admin_action_logs: '🔎 Admin action logs',
  },
  users: {
    all_users: '👥 All Users',
    user_type: 'User type',
    type_all: 'All',
    type_student: 'Student',
    type_teacher: 'Teacher',
    type_directive: 'Directive Admin',
    type_district_admin: 'District Admin',
    type_campus_group_admin: 'Campus Group Admin',
    type_school_group_admin: 'School Group Admin',
    type_unknown: 'Unknown',
    assignment: 'Assignment',
    impersonate: 'Impersonate',
    impersonate_opening: 'Opening session as',
    action_error: 'Could not complete the action. Verify the user has an ID or DNI.',
  },
  app_header: {
    school_administration: 'Schools Administration',
    user_administration: 'Users Administration 👥',
  },
  general: {
    error_msg: 'Oops! Something went wrong!. Please contact support team',
    loading: 'Loading...',
    only_positive_number: 'Please enter a positive number',
    is_required: 'This field is required',
    valid_dates: 'Please enter valid dates',
    view: 'View',
    edit: 'Edit',
    cancel: 'Cancel',
    actions: 'Actions',
    itemsPerPage: 'Items per page',
  },
  version_update: {
    title: 'A new version is available',
    text: 'Reload the page to update to the latest version.',
    button: 'Reload',
  },
};
